export const CASE_CREATE_TALENT_STORAGE_KEY = "case_create_talent_selected";
export const CASE_EDIT_TALENT_STORAGE_KEY = "case_edit_talent_selected";
export const CASE_LIST_FILTERS_STORAGE_KEY = "case_list_filters";
export const CASE_LIST_ADVANCED_FILTERS_STORAGE_KEY = "case_list_advanced_filters";
export const CASE_LIST_DISPLAY_COLUMNS_STORAGE_KEY = "case_list_display_columns";
export const CASE_LIST_APPLIED_CONDITION_NAME_STORAGE_KEY = "case_list_applied_condition_name";
export const CASE_LIST_APPLIED_CONDITION_ID_STORAGE_KEY = "case_list_applied_condition_id";
export const CASE_LIST_SORT_STORAGE_KEY = "case_list_sort";
export const CASE_LIST_DEFAULT_SEEDED_STORAGE_KEY = "case_list_default_seeded";
/**
 * Generate scoped localStorage keys for CaseMatch filter state.
 * Avoids collisions between CaseCreate and CaseEdit pages.
 * @param prefix - e.g. "case_create" or "case_edit"
 */
export const getCaseMatchStorageKeys = (prefix: string) => ({
  displayColumns: `${prefix}_match_display_columns`,
  advancedFilters: `${prefix}_match_advanced_filters`,
  appliedConditionName: `${prefix}_match_applied_condition_name`,
  appliedConditionId: `${prefix}_match_applied_condition_id`,
  defaultSeeded: `${prefix}_match_default_seeded`,
});

/** Pre-built keys for CaseCreate page */
export const CASE_CREATE_MATCH_STORAGE = getCaseMatchStorageKeys("case_create");
/** Pre-built keys for CaseEdit page */
export const CASE_EDIT_MATCH_STORAGE = getCaseMatchStorageKeys("case_edit");
